import React from "react";
import RoleContainer from "../containers/Role";

const Role = () => {
  return <RoleContainer />;
};

export default Role;
